import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type InvestorPage =
    | 'dashboard'
    | 'mi-inversion'
    | 'portfolio'
    | 'fees'
    | 'pro-ratas'
    | 'reportes'
    | 'reportes-financiero'
    | 'reportes-operativo'
    | 'reportes-documentacion'
    | 'profile'
    | 'academy';

export type AdminPage =
    | 'dashboard'
    | 'activos'
    | 'inversores'
    | 'fees'
    | 'operaciones'
    | 'reportes'
    | 'configuracion'
    | 'rendimiento';

interface NavigationState {
    currentInvestorPage: InvestorPage;
    currentAdminPage: AdminPage;
}

const initialState: NavigationState = {
    currentInvestorPage: 'dashboard',
    currentAdminPage: 'rendimiento',
};

const navigationSlice = createSlice({
    name: 'navigation',
    initialState,
    reducers: {
        setInvestorPage: (state, action: PayloadAction<InvestorPage>) => {
            state.currentInvestorPage = action.payload;
        },
        setAdminPage: (state, action: PayloadAction<AdminPage>) => {
            state.currentAdminPage = action.payload;
        },
        resetNavigation: (state) => {
            state.currentInvestorPage = 'dashboard';
            state.currentAdminPage = 'rendimiento';
        },
    },
});

export const { setInvestorPage, setAdminPage, resetNavigation } = navigationSlice.actions;
export default navigationSlice.reducer;
